import { Typography } from '@lyearn/ui';
import { FilterOption } from '@/components/Filter/types';
import { SkillDetailsFragment } from '@/modules/skill-matrix/graphql/fragment/generated/SkillDetails';

export type SkillMenuItem = SkillDetailsFragment & FilterOption;

export const getSkillFilterOption = (skill: SkillDetailsFragment): SkillMenuItem => {
  return {
    ...skill,
    value: skill.id,
    label: skill.name,
  };
};

export const SkillItemRenderer = ({ option }: { option: FilterOption }) => (
  <Typography
    className="truncate px-12 py-4"
    color="text-text-primary"
    title={option.label}
    variant="body-short-02">
    {option.label}
  </Typography>
);
